import $ from 'jquery';
import BaseComponent from '../../../general/js/base-component';
import { EVENT_FIELD_VALIDATION_FAILED } from "../../form/js/async-form.component";

export default class CollapsedComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.trigger = this.refs.trigger;
        this.content = this.refs.content;

        this.isOpened = this.options.isOpened || false;
        this.onInnerFieldValidationFailed = this.onInnerFieldValidationFailed.bind(this);
        this.toggle = this.toggle.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['trigger', 'content']
    }

    init() {
        if (!this.trigger) {
            return;
        }
        this.$content = $(this.content);
        this.trigger.addEventListener('click', this.toggle);

        if (this.isOpened) {
            this.open();
        }

        this.element.addEventListener(EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
    }

    toggle(e) {
        if (this.isOpened) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.element.classList.add('is-opened');
        this.$content.slideDown(400, () => {
            this.inProgress = false;
        });
        this.isOpened = true;
    }

    close() {
        this.element.classList.remove('is-opened');
        this.$content.slideUp(400, () => {
            this.inProgress = false;
        });
        this.isOpened = false;
    }

    onInnerFieldValidationFailed(e) {
        if (!this.isOpened) {
            this.open();
        }
    }

    onDestroy() {
        this.trigger.removeEventListener('click', this.toggle);
        this.element.removeEventListener(EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
    }
}



// WEBPACK FOOTER //
// ./app/components/collapsed/js/collapsed.component.js